<script>
  import { onMount } from 'svelte'

  import CardHeadline   from "/components/Widgets/CardHeadline";
  import PageHeader     from '/components/Atoms/PageHeader';
  import CardsGroupProgramme     from '/components/Groups/CardsGroupProgramme';
  import CardExhibition from '/components/Widgets/CardExhibition.svelte'
  import CardProjectEvent from '/components/Widgets/CardProjectEvent.svelte'
  import { datesToString } from '/components/Atoms/EventDate'

  import { styleVars, pannable, sortEvents } from '/helper'
  import { _ } from 'svelte-i18n'

  export let data

  const Programme = data?.Programme || []

  const months = [
    { abbr: $_("months.abbr.Jan") },
    { abbr: $_("months.abbr.Feb") },
    { abbr: $_("months.abbr.Mar") },
    { abbr: $_("months.abbr.Apr") },
    { abbr: $_("months.abbr.May") },
    { abbr: $_("months.abbr.Jun") },
    { abbr: $_("months.abbr.Jul") },
    { abbr: $_("months.abbr.Aug") },
    { abbr: $_("months.abbr.Sep") },
    { abbr: $_("months.abbr.Oct") },
    { abbr: $_("months.abbr.Nov") },
    { abbr: $_("months.abbr.Dec") },
  ]

  const displayMonths = [ ...months, months[0] ]

  let yearPercentage = 0
  let bgPosX = "100%"

  let thisYear

  onMount( () => {
    var now = new Date();
    var start = new Date(now.getFullYear(),0,1)
    var end = new Date(now.getFullYear(),11,31)

    var q = Math.abs(now-start);
    var d = Math.abs(end-start);
    var fraction = (q/d)
    yearPercentage = fraction * 100
    bgPosX = 100 - yearPercentage + "%"

    thisYear = now.getFullYear()
  })

  function handlePanMove(obj) {
    //console.log(obj.target, obj.detail.dx, obj.target.scrollLeft)
    obj.target.scrollLeft -= obj.detail.dx
  }

  // get main programme -> event and some projects

  const programme = Programme.filter((result) =>
    result.typeHandle === "event" ||
    result.projectType?.toLowerCase() != "residency" && result.projectType?.toLowerCase() != "partner"
  ).sort(sortEvents)

  // get residencies and partner -> projects by type

  const residencies = Programme.filter((result) => result.projectType?.toLowerCase() == "residency").sort(sortEvents)
  const partners = Programme.filter((result) => result.projectType?.toLowerCase() == "partner").sort(sortEvents)

  // map to components

  function toComponent(e, type) {
    const dates = e?.eventDates?.[0]

    // collect and process information

    const card = {
      date: e.dateDisplay || datesToString(dates?.startDateAndTime, dates?.endDateAndTime),
      faded: type == "programme" && dates?.endDateAndTime && ( new Date(dates?.endDateAndTime) < new Date() ),
      title: e.teaser,
      subtitle: e.title,
      image: e?.backgroundImage?.[0]?.url,
      type: e.featured?.[0] === "true" ? "large" : "small",
      link: { slug: e.slug, section: (e.typeHandle=="programme"?"project":e.typeHandle)+"s"} // pluralize typeHandle to get section
    }

    // chose appropriate component and configure it

    const component = {
      component: CardExhibition,
      props: {
        ...card,
        large: card.type === "large"
        },
      type: card.type
    }
    return component
  }

  const programme_cards = programme.filter(e => !!e.title).map(e => toComponent(e, "programme"))
  const residencies_cards = residencies.map(toComponent)
  const partners_cards = partners.map(toComponent)

</script>


<PageHeader>
  {$_("programme.title")}
</PageHeader>

<section>
  <CardHeadline>
    {$_("programme.year_long_festival")}
  </CardHeadline>

  <nav class="dateselector">

    <ol class="years">
      <li class="year this" style={styleVars({ bgPosX })} title={`${thisYear} (${yearPercentage.toFixed(2)}%)`}>
        {thisYear}
      </li>
      <li class="year next" title={`${thisYear+1}`}>
        {thisYear+1}
      </li>
    </ol>

    <div class="months-wrapper">
      <ol class="months"
        use:pannable
        on:panmove={handlePanMove}
        >
        { #each displayMonths as month }
          <li class="month">
            { month.abbr }
          </li>
        { /each }
      </ol>
    </div>

  </nav>

  <CardsGroupProgramme cards={ programme_cards } />

</section>

{#if residencies_cards.length > 0}
  <section>
    <CardHeadline>
      Residents
    </CardHeadline>
    <br />
    <CardsGroupProgramme cards={ residencies_cards } />
  </section>
{/if}

{#if partners_cards.length > 0}
  <section>
    <CardHeadline>
      Partner Projects
    </CardHeadline>
    <br />
    <CardsGroupProgramme cards={ partners_cards } />
  </section>
{/if}


<style lang="scss">

  section {
    @include grid-padding;
    margin-bottom: 60px;
    &br {
      height: 20px;
    }
  }

  .dateselector {
    @include typo-grotesk-text-24;
    user-select: none;
    margin-bottom: 20px;
  }

  .years, .months-wrapper {
    margin-top: 10px;
    @include media-small {
      margin-top: 8px;
    }
  }

  .months-wrapper { // to hide the scroll bar
    overflow: hidden;
    @include grid-margin(-1);

    height: $pill-height-large;
    @include media-small {
      height: $pill-height-small;
    }
  }

  .months {
    overflow: hidden;
    display: grid;
    grid-template-columns: repeat( 13, 1fr );
    grid-auto-flow: column;
    @include grid-padding;

    overflow: hidden;
    overflow-x: auto;

    column-gap: 10px;
    @include media-small {
      column-gap: 8px;
    }
  }

  .year, .month {
    background-color: $color-gray6;
    border-radius: $pill-height-large / 2;
    line-height: $pill-height-large;
    @include media-small {
      line-height: $pill-height-small;
      border-radius: $pill-height-large / 2;
    }

    padding: 0 20px;
    @include media-small {
      padding: 0 15px;
    }
  }

  .year {
    box-shadow: $shadow;
  }

  .years {
    display: flex;
    width: 100%;

    .this {
      flex: 1;
      background: linear-gradient(90deg, $color-mint 50%, $color-gray6 50%);
      background-size: 200% 200%;
      background-position-x: var(--bgPosX);
    }

    .next {
      margin-left: 10px;
      @include media-small {
        margin-left: 8px;
      }
    }

  }

  .month {

  }


</style>
